export const ChangeStatusTypes = {
  NoChange: "No Action",
  Update: "Update"
};
